import {Component, Input, OnInit} from "@angular/core";
import {Role} from "../../../shared/api/roles/api.models";
import {Permission} from "../../../shared/api/permissions/api.models";
import {Utils} from "../../../shared/utils.service";
import {Api} from "../../../shared/api.service";
import {Observable} from "rxjs/Observable";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'permission-modal',
    template: require('./permission.modal.html'),
    styles: [require('./permission.modal.scss')]
})

export class PermissionModal implements OnInit {
    @Input() role: Role;
    @Input() permissions: Permission[];
    @Input() current: Permission[];

    protected selectables: Permission[] = [];
    protected selected: Permission[]    = [];
    protected saving: boolean = false;
    protected errorDuringSave: boolean = false;

    constructor(public activeModal: NgbActiveModal, private utils: Utils, private api: Api) {}

    ngOnInit() {
        this.permissions.forEach((permission: Permission) => {
            if (this.current.indexOf(permission) === -1) {
                this.selectables.push(permission);
            } else {
                this.selected.push(permission);
            }
        });

        this.sort();
    }

    grant(permission: Permission) {
        this.selected.push(permission);
        this.selectables.splice(this.selectables.indexOf(permission), 1);

        this.sort();
    }

    revoke(permission: Permission) {
        this.selectables.push(permission);
        this.selected.splice(this.selected.indexOf(permission), 1);

        this.sort();
    }

    save() {
        this.saving = true;
        this.errorDuringSave = false;

        let mainObservable: Observable<any>;

        this.current.forEach((permission: Permission) => {
            if (this.selected.indexOf(permission) === -1) {
                if (!mainObservable) {
                    mainObservable = this.api.roles().permissions(this.role.id).revoke(permission.id);
                } else {
                    mainObservable = mainObservable.flatMap(() => {
                        return this.api.roles().permissions(this.role.id).revoke(permission.id);
                    });
                }
            };
        });

        this.selected.forEach((permission: Permission) => {
            if (this.current.indexOf(permission) === -1) {
                if (!mainObservable) {
                    mainObservable = this.api.roles().permissions(this.role.id).grant(permission.id);
                } else {
                    mainObservable = mainObservable.flatMap(() => {
                        return this.api.roles().permissions(this.role.id).grant(permission.id);
                    });
                }
            }
        });

        if (!mainObservable) {
            this.saving = false;
            return;
        }

        mainObservable.subscribe(
            () => {
                this.saving = false;
                this.activeModal.close(this.selected);
            },
            () => {
                this.errorDuringSave = true;
            }
        );
    }

    private sort() {
        this.utils.sortList(this.selectables, 'description');
        this.utils.sortList(this.selected, 'description');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/roles/components/permission.modal.ts